import React from "react";
import "./Footer.css";
import locationImg from "../images/location.png";
import callImg from "../images/call.png";
const Footer = () => {
  return (
    <footer className="text-white p-3" style={{ background: "#23182C" }}>
      <div className="container mx-auto">
        <div className="row">
          <div className="col-12 col-md-3">
            <h3 className="brand_text">Quick Link</h3>
            <ul>
              <li>link-1</li>
              <li>link-2</li>
              <li>link-3</li>
              <li>link-4</li>
              <li>link-5</li>
              <li>link-6</li>
            </ul>
          </div>
          <div className="col-12 col-md-3">
            <h3 className="brand_text">Quick Link</h3>
            <ul>
              <li>link-1</li>
              <li>link-2</li>
              <li>link-3</li>
              <li>link-4</li>
              <li>link-5</li>
              <li>link-6</li>
              <li>link-7</li>
              <li>link-8</li>
              <li>link-9</li>
              <li>link-10</li>
            </ul>
          </div>
          <div className="col-12 col-md-2">
            <h3 className="brand_text">Link</h3>
            <ul>
              <li>item-1</li>
              <li>item-2</li>
              <li>item-3</li>
              <li>item-4</li>
              <li>item-5</li>
              <li>item-6</li>
            </ul>
          </div>
          <div className="col-12 col-md-4">
            <h3 className="brand_text">Contact</h3>
            <ul>
              <li className="d-flex">
                <img
                  width="20"
                  height="20"
                  className="mr-2"
                  src={locationImg}
                  alt="location"
                />
                <p>657 Imran Street Pinkixvaille, PA 19460, USA</p>
              </li>
              <li>
                <div className="d-flex">
                  <img
                    width="20"
                    height="20"
                    className="mr-2"
                    src={callImg}
                    alt="location"
                  />
                  <p>+1234 567 8900</p>
                </div>
                <div className="d-flex">
                  {" "}
                  <img
                    width="20"
                    height="20"
                    className="mr-2"
                    src={callImg}
                    alt="location"
                  />
                  <p>+1234 567 8900</p>
                </div>
              </li>
              <li className="d-flex">
                <img
                  width="20"
                  height="20"
                  className="mr-2"
                  src='https://image.flaticon.com/icons/png/128/646/646094.png'
                  alt="location"
                />
                <p>codingBird@yahoo.com</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
